// extracted by mini-css-extract-plugin
export default {"title":"_0e3c76fbc4","inner_title":"_211936e145","charge_btn":"_4abfef19a3"};